export default __webpack_public_path__ + "static/media/sw-4.34b6bf09.svg";